import { headers } from '../common'

async function getListData(params) {

  const queryParams = new URLSearchParams(params);

  return fetch('/api/transactions?' + queryParams)
    .then(res => {
      return res;
    })
    .catch(errors => {
      return errors;
    })
}

async function cancel(transactionId) {
  return fetch('/api/transactions/' + transactionId + '/cancel', {
    method: 'POST',
    headers: headers,
  }).then(res => {
    return res;
  }).catch(errors => {
    return errors;
  })
}

export { getListData, cancel }
